import { Eye, Plus, Users } from "lucide-react"

import { Button } from "@/components/ui/button"

// Shared empty state for both tabs. "by" carries an invite CTA; "with" is purely
// informational (nothing to do until someone shares with you).
const VARIANTS = {
  by: {
    Icon: Users,
    title: "You haven't shared any projects",
    copy: "Invite a co-author, agent, or beta reader to follow along on a manuscript. They'll be able to read and comment — nothing more.",
    cta: "Invite to a project",
  },
  with: {
    Icon: Eye,
    title: "No projects shared with you",
    copy: "When another customer grants you access to one of their projects, it'll show up here as a read-only document.",
    cta: null,
  },
}

export default function AccessEmpty({ variant, onInvite }) {
  const config = VARIANTS[variant] ?? VARIANTS.by
  const { Icon } = config

  return (
    <div className="flex flex-col items-center rounded-[14px] border border-border bg-card px-7 py-14 text-center">
      <div className="mb-[17px] grid size-14 place-items-center rounded-[16px] border border-border bg-secondary">
        <Icon className="size-[25px] text-ink-3" strokeWidth={1.7} />
      </div>
      <h4 className="font-display text-base font-bold tracking-[-0.2px] text-foreground">{config.title}</h4>
      <p className="mt-1.5 max-w-[380px] text-[13px] leading-[1.55] text-ink-3">{config.copy}</p>
      {config.cta && onInvite && (
        <Button className="mt-5" onClick={onInvite}>
          <Plus className="size-4" strokeWidth={2} />
          {config.cta}
        </Button>
      )}
    </div>
  )
}
